<template>
  <div>
    <el-card v-loading="loading">
      <!--el-select v-model="instrumentType" :content="$t('manual.selectInstrumentType')" @change="changeInstrumentType">
        <el-option
          v-for="item in instrumentTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select-->
      <el-cascader
        v-model="instrumentType"
        :options="instrumentType_options"
        :props="{ expandTrigger: 'hover' }"
        :placeholder="$t('manual.selectInstrumentType')"
        @change="changeInstrumentType"
      >
      </el-cascader>
      <el-select
        v-if="isContinuityType"
        v-model="selectedGroupId"
        placeholder="請選擇孔位"
        @change="changeGroup"
      >
        <el-option
          v-for="item in instrumentGroupList"
          :key="item._id"
          :label="item.name"
          :value="item._id"
        />
      </el-select>
      <el-select v-model="timestamp" :content="$t('manual.selectTimestamp')" @change="changeTimestamp">
        <el-option
          v-for="item in timestampList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select v-if="!isContinuityType" v-model="area" :placeholder="$t('manual.selectArea')" @change="changeArea">
        <el-option
          v-for="item in areaList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <span v-if="editPass && !isContinuityType" style="margin-left: 10px; margin-right: 10px;">
        {{$t('manual.enableEdit')}}
        <el-switch v-model="enableEdit" />
      </span>
      <el-button
        v-if="enableEdit && !isContinuityType"
        @click="uploadOutput"
      >
        {{$t('manual.uploadEdit')}}
      </el-button>
    </el-card>
    <el-card v-if="instrumentTypeInfo">
      {{ instrumentTypeInfo }}
    </el-card>
    <el-card v-if="instrumentList.length > 0">
      <hot-table id="hot-container" ref="hot" root="hot" :settings="settings" />
    </el-card>
  </div>
</template>

<script>
import moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import { HotTable } from '@handsontable/vue';
import { EDIT_PASS_TABLE } from '@/constants/userRoles';
import { InstrumentTypeCascaderOption, TemplateDownloadLinkSelectOption } from '@/constants/instrumentTemplateDLOption';
import manualProjectMixin from '@/lib/base/manualProject';

MomentTimeZone();
export default {
  mixins: [manualProjectMixin],
  components: {
    HotTable,
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    settings() {
      const vm = this;
      return {
        data: vm.instrumentList,
        fixedColumnsLeft: 1,
        colHeaders: vm.columnsHeader,
        rowHeaders: true,
        manualRowResize: true,
        manualColumnResize: true,
        manualRowMove: true,
        customBorders: true,
        columnSorting: true,
        height: 600,
        width: '100%',
        columns: vm.columns,
        licenseKey: 'non-commercial-and-evaluation',
      };
    },
    columns() {
      let constCol = this.constCol;

      if (this.isContinuityType) {
        constCol = [...constCol, 'depth', 'rawResult'];
      } else {
        const insTypeObjKey = Object.keys(this.getInstrumentType || {});
        if (insTypeObjKey.includes('A+') && insTypeObjKey.includes('A-')
          && this.getInstrumentType['A+'] && this.getInstrumentType['A-']) {
          constCol = constCol.filter(ele => ele !== 'reading' && ele !== 'R0');
        }

        if (this.isLCType) {
          constCol = constCol
            .filter(ele => !['R0', 'reading'].includes(ele))
            .concat([
              'Gate1initial', 'Gate2initial', 'Gate3initial',
              'Gate1', 'Gate2', 'Gate3',
            ]);
        }
      }

      return this.col
        .filter(ele => {
          const keys = Object.keys(this.getInstrumentType || {});
          return (keys.includes(ele.data) && this.getInstrumentType[ele.data]) || constCol.includes(ele.data);
        })
        .map(ele => {
          let readOnly = ele.readOnly;

          if (!this.isContinuityType) {
            switch (ele.data) {
              case 'A+':
              case 'A-':
              case 'reading':
              case 'result':
              case 'Gate1':
              case 'Gate2':
              case 'Gate3':
                readOnly = !this.enableEdit;
                break;
            }
          }

          return { data: ele.data, readOnly, editor: ele.editor, selectOptions: ele.selectOptions };
        });
    },

    columnsHeader() {
      let constCol = this.constCol;

      if (this.isContinuityType) {
        constCol = [...constCol, 'depth', 'rawResult'];
      } else {
        const insTypeObjKey = Object.keys(this.getInstrumentType || {});
        if (insTypeObjKey.includes('A+') && insTypeObjKey.includes('A-')
          && this.getInstrumentType['A+'] && this.getInstrumentType['A-']) {
          constCol = constCol.filter(ele => ele !== 'reading' && ele !== 'R0');
        }

        if (this.isLCType) {
          constCol = constCol
            .filter(ele => !['R0', 'reading'].includes(ele))
            .concat([
              'Gate1initial', 'Gate2initial', 'Gate3initial',
              'Gate1', 'Gate2', 'Gate3',
            ]);
        }
      }

      const col = this.col.map((ele, index) => ({ data: ele.data, index }))
        .filter(ele => {
          const keys = Object.keys(this.getInstrumentType || {});
          return (keys.includes(ele.data) && this.getInstrumentType[ele.data]) || constCol.includes(ele.data);
        });

      return this.colHeader.filter((_, index) => col.findIndex(c => c.index === index) >= 0);
    },
    isContinuityType() {
      const instrumentTypeName = this.instrumentType?.[1];
      if(!instrumentTypeName) return false;
      return instrumentTypeName.includes('SIS') || instrumentTypeName.includes('SID') || instrumentTypeName.includes('ISS (傾斜)');
    },
    selectedInstrumentTypeName() {
      return Array.isArray(this.instrumentType) ? this.instrumentType?.[1] : this.instrumentType;
    },
    isLCType() {
      const name = this.selectedInstrumentTypeName;
      if (!name) return false;
      return name === 'LC (支撐荷重計)' || (name.includes('LC') && name.includes('支撐荷重計'));
    },
    getInstrumentType(){
      const instrumentType = this.instrumentType?.[1];
      return this.instrumentTypeList.find(ele=>{
        return ele.name === instrumentType;
      });
    },
    userRole() {
      return this.$store.getters['user/details'].roles;
    },
    editPass() {
      return !!EDIT_PASS_TABLE[this.userRole];
    },
    instrumentType_options() {
      return InstrumentTypeCascaderOption.map(ele=>{
        return {
          value: ele.value,
          label: ele.label,
          children: ele.children.map(child=>{
            const instrumentType = this.instrumentTypeList.find(instrumentType=>{
              return child.value === instrumentType.name;
            });
            return {
              value: child.value,
              label: child.label,
              disabled: !instrumentType,
            };
          }),
        };
      });
    },
  },
  data(){
    return {
      constCol: [
        'instrumentName',
        'unit',
        'R0',
        'F1',
        'reading',
        'result',
        'lastOutput',
        'diff',
        'WL',
        'AL',
        'WSL',
        'remark',
      ],
      col: [
        { data: 'instrumentName', readOnly: true },
        { data: 'depth', readOnly: true },
        { data: 'unit', readOnly: true },

        { data: 'R0', readOnly: true },

        // === LC: Gate 初值（readonly）===
        { data: 'Gate1initial', readOnly: true },
        { data: 'Gate2initial', readOnly: true },
        { data: 'Gate3initial', readOnly: true },

        { data: 'A+initial', readOnly: true },
        { data: 'A-initial', readOnly: true },

        { data: 'F1', readOnly: true },

        { data: 'reading' },

        // === LC: Gate 讀值（可編輯；會受 enableEdit 控制）===
        { data: 'Gate1' },
        { data: 'Gate2' },
        { data: 'Gate3' },

        { data: 'A+' },
        { data: 'A-' },

        { data: 'result', readOnly: true },
        { data: 'rawResult', readOnly: true },
        { data: 'lastOutput', readOnly: true },
        { data: 'diff', readOnly: true },
        { data: 'WL', readOnly: true },
        { data: 'AL', readOnly: true },
        { data: 'WSL', readOnly: true },

        { data: 'remark', readOnly: true },
      ],
      colHeader: [
        '儀器名稱',
        '深度',
        '單位',
        '初值',
        'Gate1 初值',
        'Gate2 初值',
        'Gate3 初值',
        '正向初值',
        '負向初值',
        '係數',
        '讀值',
        'Gate1 讀值',
        'Gate2 讀值',
        'Gate3 讀值',
        '正向讀值',
        '負向讀值',
        '變化量',
        '變化量(未累加)',
        '前次變化量',
        '差值',
        '注意值',
        '警戒值',
        '行動值',
        '備註',
      ],

      loading: false,

      originInstrumentList: [],
      outputLoadedTypes: [],
      loadedInstrumentTypes: [],
      updateTableTimer: null,

      timestampList: [],
      areaList: [],
      instrumentList: [],

      timestamp: '',
      area: '',

      selectedGroupId: '',
      instrumentGroupList: [],

      instrumentTypeList: [],
      instrumentType: '',

      instrumentTypeInfo: '',

      enableEdit: false,
    };
  },
  async mounted(){
    this.loading = true;
    await this.getInstrumentTypeList();
    this.loading = false;
  },
  methods: {
    async getInstrumentTypeList(){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: 'instrument_type',
      });
      this.instrumentTypeList = res.data.filter(ele => ele.manual).map(ele=>{
        return {
          ...ele,
          value: ele.name,
          label: ele.name,
        };
      }).sort((a,b) => a.value[0].localeCompare(b.value[0]));
    },
    async getInstrumentsByType(typeId){
      if (this.loadedInstrumentTypes.includes(String(typeId))) return;

      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrumentByType/${this.manualProjectId}/${typeId}`,
      });
      const loadedIds = new Set(this.originInstrumentList.map(ins => String(ins._id)));
      const newInstruments = res.data.filter(ins => !loadedIds.has(String(ins._id)));
      newInstruments.forEach(ins => {
        ins.data.sort((a, b) => a.startDate - b.startDate);
      });
      this.originInstrumentList = this.originInstrumentList.concat(newInstruments);
      this.loadedInstrumentTypes.push(String(typeId));
    },
    async getOutput(instrumentTypeId){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getAllManualInstrumentOutput/${this.manualProjectId}`,
        params: { instrument_type: instrumentTypeId },
      });

      const outputList = res.data;

      const typeIdStr = String(instrumentTypeId);
      this.originInstrumentList = this.originInstrumentList.map(ins => {
        if (String(ins.instrument_type._id) !== typeIdStr) return ins;
        const instrumentOutputs = outputList.filter(output => output.name === ins.data[0].name).map(output => {
          return {
            ...output,
            diff: (![undefined, NaN, null].includes(output.lastOutput) && ![undefined, NaN, null].includes(output.reading2)) ? Number(output.reading2 - output.lastOutput).toFixed(4) : '',
          };
        });
        return {
          ...ins,
          outputList: instrumentOutputs,
        };
      });
      this.outputLoadedTypes.push(typeIdStr);
    },

    async changeInstrumentType(){
      const instrumentType = this.getInstrumentType;
      if(!instrumentType) return;

      this.loading = true;
      this.timestamp = '';
      this.area = '';
      this.instrumentList = [];
      this.timestampList = [];
      this.selectedGroupId = '';
      this.instrumentGroupList = [];

      try {
        const typeId = String(this.getInstrumentType?._id);
        await this.getInstrumentsByType(typeId);

        if (this.isContinuityType) {
          await this.loadGroupList();
        } else {
          if(!this.outputLoadedTypes.includes(typeId)) {
            const cachedCount = this.originInstrumentList.filter(ins =>
              this.outputLoadedTypes.includes(String(ins.instrument_type._id)),
            ).length;
            if(cachedCount > 300) {
              this.outputLoadedTypes = [];
              this.originInstrumentList = this.originInstrumentList.map(ins => ({ ...ins, outputList: [] }));
            }
            await this.getOutput(typeId);
          }

          this.getTimestampList();
          this.getAreaList();
        }
      } finally {
        this.instrumentTypeInfo = (instrumentType) ? instrumentType.info : '';
        this.loading = false;
      }
    },

    async loadGroupList(){
      const allGroups = await this.$store.dispatch('data/getProjectInstrumentGroupList', {
        projectId: this.manualProjectId,
      });
      const typeInstrumentIds = new Set(
        this.originInstrumentList
          .filter(ins => String(ins.instrument_type._id) === String(this.getInstrumentType._id))
          .map(ins => String(ins._id)),
      );
      this.instrumentGroupList = allGroups.filter(g =>
        g.instrumentList.some(gi => typeInstrumentIds.has(String(gi.instrument))),
      );
    },

    async changeGroup(){
      this.timestamp = '';
      this.timestampList = [];
      this.instrumentList = [];
      if (!this.selectedGroupId) return;

      this.loading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getInstrumentGroupTimestampList/${this.manualProjectId}/${this.selectedGroupId}`,
      });
      this.timestampList = [...res.data].sort(
        (a, b) => new Date(b).getTime() - new Date(a).getTime(),
      ).map(t => ({ value: t, label: moment(t).tz('Asia/Taipei').format('YYYY-MM-DD HH:mm') }));
      this.loading = false;
    },

    async changeTimestamp(){
      if (this.isContinuityType) {
        await this.loadGroupOutput();
      } else {
        if (this.area) {
          this.getInstrumentsFromTable();
        } else {
          this.instrumentList = [];
        }
      }
    },

    async loadGroupOutput(){
      if (!this.selectedGroupId || !this.timestamp) return;

      this.loading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getInstrumentGroupOutput/${this.manualProjectId}/${this.selectedGroupId}`,
        params: { date: this.timestamp },
      });

      const group = this.instrumentGroupList.find(g => g._id === this.selectedGroupId);
      const depthMap = new Map(
        (group?.instrumentList || []).map(gi => [String(gi.instrument), gi.depth]),
      );

      this.instrumentList = res.data.map(output => {
        const ins = this.originInstrumentList.find(i => i.data[0].name === output.name);
        const instrumentDataIndex = ins ? this.getDataByTime(ins, new Date(this.timestamp)) : -1;
        const data = ins?.data?.[instrumentDataIndex] || {};

        const WL_plus = ![null, NaN, undefined].includes(data.WL_plus);
        const WL_minus = ![null, NaN, undefined].includes(data.WL_minus);
        const AL_plus = ![null, NaN, undefined].includes(data.AL_plus);
        const AL_minus = ![null, NaN, undefined].includes(data.AL_minus);
        const WSL_plus = ![null, NaN, undefined].includes(data.WSL_plus);
        const WSL_minus = ![null, NaN, undefined].includes(data.WSL_minus);

        let WL = '';
        if (WL_plus && WL_minus) WL = `${data.WL_plus}/${data.WL_minus}`;
        else if (WL_plus) WL = `${data.WL_plus}`;
        else if (WL_minus) WL = `${data.WL_minus}`;
        let AL = '';
        if (AL_plus && AL_minus) AL = `${data.AL_plus}/${data.AL_minus}`;
        else if (AL_plus) AL = `${data.AL_plus}`;
        else if (AL_minus) AL = `${data.AL_minus}`;
        let WSL = '';
        if (WSL_plus && WSL_minus) WSL = `${data.WSL_plus}/${data.WSL_minus}`;
        else if (WSL_plus) WSL = `${data.WSL_plus}`;
        else if (WSL_minus) WSL = `${data.WSL_minus}`;

        const depth = ins ? depthMap.get(String(ins._id)) : undefined;

        return {
          instrumentName: output.name,
          depth,
          unit: data.unit,
          result: output.reading2,
          rawResult: this.computedRawResult(output, data),
          'A+': output['A+'],
          'A-': output['A-'],
          reading: output.reading,
          lastOutput: output.lastOutput,
          diff: (![undefined, NaN, null].includes(output.lastOutput) && ![undefined, NaN, null].includes(output.reading2))
            ? Number(output.reading2 - output.lastOutput).toFixed(4) : '',
          remark: output.remark,
          WL, AL, WSL,
        };
      }).sort((a, b) => (b.depth ?? 0) - (a.depth ?? 0));

      this.loading = false;
      this.updateTable();
    },

    getTimestampList(){
      const instrumentType = this.getInstrumentType;
      if(!instrumentType) return;

      const instrumentTypeName = instrumentType.name;

      let instrumentList = this.originInstrumentList.filter(ele => {
        return ele.instrument_type.name === instrumentTypeName;
      });

      if (this.area) {
        instrumentList = instrumentList.filter(ins => ins.area === this.area);
      }

      const timestampSet = new Set();
      instrumentList.forEach(ins => {
        (ins.outputList || []).forEach(output => {
          timestampSet.add(output.TIMESTAMP);
        });
      });

      this.timestampList = [...timestampSet].sort(
        (a, b) => new Date(b).getTime() - new Date(a).getTime(),
      ).map(ele => ({ value: ele, label: ele }));

      if(this.timestampList.findIndex(t => t.value === this.timestamp) < 0) {
        this.timestamp = '';
      }
    },

    changeArea(){
      const prevTimestamp = this.timestamp;
      this.getTimestampList();
      if (prevTimestamp && !this.timestamp) {
        this.$notify({
          title: '注意',
          message: `選定區域不存在時間為 ${prevTimestamp} 的數據`,
          type: 'warning',
        });
      }
      this.getInstrumentsFromTable();
    },
    getAreaList(){
      const instrumentType = this.getInstrumentType;
      if(!instrumentType) return;

      const instrumentTypeName = instrumentType.name;

      let areaList = this.originInstrumentList.filter(ele=>{
        return (!instrumentTypeName || ele.instrument_type.name === instrumentTypeName);
      }).map(ele=>{
        return ele.area;
      }).reduce((acc,cur)=>{
        if(acc.find(ele=>ele==cur)) return acc;
        else {
          acc.push(cur);
          return acc;
        }
      },[]);
      this.areaList = areaList.map(ele=>{
        return {
          value: ele,
          label: ele,
        };
      });

      if(this.areaList) {
        let areaIndex = this.areaList.findIndex(area => {
          return area.value === this.area;
        });
        if(areaIndex < 0) this.area = '';
      }
    },

    getInstrumentsFromTable(){
      const instrumentType = this.getInstrumentType;
      if(!instrumentType || !this.timestamp || !this.area) {
        this.instrumentList = [];
        return;
      }
      const instrumentTypeName = instrumentType.name;

      this.instrumentList = this.originInstrumentList.filter(ins=>{
        let isArea = ins.area === this.area;
        let isTime = (ins.outputList || []).findIndex(output=>{
          return output.TIMESTAMP === this.timestamp;
        }) >= 0;
        let isType = !instrumentTypeName || instrumentTypeName === ins.instrument_type.name;
        return isArea && isTime && isType;
      }).map(ins => {
        const outputIndex = ins.outputList.findIndex(output=>{
          return output.TIMESTAMP === this.timestamp;
        });
        const instrumentDataIndex = this.getDataByTime(ins, new Date(this.timestamp));

        const data = ins.data?.[instrumentDataIndex] || {};
        const other = data.other_value || {};

        const g1i = other.gage1_initial ?? data.gage1_initial ?? null;
        const g2i = other.gage2_initial ?? data.gage2_initial ?? null;
        const g3i = other.gage3_initial ?? data.gage3_initial ?? null;

        const out = ins.outputList?.[outputIndex] || {};
        const readingsObj = out.readings || {};
        const g1 = readingsObj.Gate1 ?? out.Gate1 ?? null;
        const g2 = readingsObj.Gate2 ?? out.Gate2 ?? null;
        const g3 = readingsObj.Gate3 ?? out.Gate3 ?? null;

        let WL_plus = ![null,NaN,undefined].includes(data.WL_plus);
        let WL_minus = ![null,NaN,undefined].includes(data.WL_minus);
        let AL_plus = ![null,NaN,undefined].includes(data.AL_plus);
        let AL_minus = ![null,NaN,undefined].includes(data.AL_minus);
        let WSL_plus = ![null,NaN,undefined].includes(data.WSL_plus);
        let WSL_minus = ![null,NaN,undefined].includes(data.WSL_minus);

        let WL = '';
        if(WL_plus && WL_minus) WL = `${data.WL_plus}/${data.WL_minus}`;
        else if(WL_plus) WL = `${data.WL_plus}`;
        else if(WL_minus) WL = `${data.WL_minus}`;
        let AL = '';
        if(AL_plus && AL_minus) AL = `${data.AL_plus}/${data.AL_minus}`;
        else if(AL_plus) AL = `${data.AL_plus}`;
        else if(AL_minus) AL = `${data.AL_minus}`;
        let WSL = '';
        if(WSL_plus && WSL_minus) WSL = `${data.WSL_plus}/${data.WSL_minus}`;
        else if(WSL_plus) WSL = `${data.WSL_plus}`;
        else if(WSL_minus) WSL = `${data.WSL_minus}`;

        return {
          _id: out._id,
          instrumentName: ins.data?.[0]?.name,

          result: out.reading2,

          'A+initial': data['A+'],
          'A-initial': data['A-'],
          F1: data.F1,
          R0: data.R0,
          offset: data.offset,

          Gate1initial: g1i,
          Gate2initial: g2i,
          Gate3initial: g3i,
          Gate1: g1,
          Gate2: g2,
          Gate3: g3,

          'A+': out['A+'],
          'A-': out['A-'],
          reading: out.reading,

          lastOutput: out.lastOutput,
          diff: out.diff,
          unit: data.unit,
          remark: out.remark,

          WL, AL, WSL,
        };
      });

      this.updateTable();
    },
    computedRawResult(output, data){
      // 累加前的單點變化量（廠商定義的「變化量」），算法與 InstrumentGroupEdit.vue 的 computedOutput 一致
      const A_plus = output['A+'] ? output['A+'] : 0;
      const A_minus = output['A-'] ? output['A-'] : 0;
      const A_plusInitial = data['A+'] ? data['A+'] : 0;
      const A_minusInitial = data['A-'] ? data['A-'] : 0;

      if (!((output['A+'] === 0 || output['A+']) && (output['A-'] === 0 || output['A-']))) return '';

      const front = data.F1 * A_plus - data.F1 * A_minus;
      const rear = data.F1 * A_plusInitial - data.F1 * A_minusInitial;
      return (front - rear + data.offset).toFixed(4);
    },
    getDataByTime(instrument, time){
      let index = -1;
      for(let data of instrument.data){
        index++;
        if(moment(data.startDate).isAfter(time)) {
          index--;
          break;
        }
      }
      return index;
    },
    updateTable() {
      clearTimeout(this.updateTableTimer);
      this.updateTableTimer = setTimeout(() => {
        this.$refs.hot?.hotInstance?.loadData(this.instrumentList);
      }, 100);
    },
    uploadOutput(){
      const timestamp = new Date(this.timestamp);

      let outputList = this.originInstrumentList.map(ele=>{
        if(ele.area === this.area && ele.instrument_type.name === this.selectedInstrumentTypeName)
        {
          let instrument_data = this.instrumentList.find(ins => ins.instrumentName === ele.data[0].name);
          const result = this.columns.reduce((pre, cur)=>{
            if(!cur.readOnly) pre[cur.data] = instrument_data?.[cur.data];
            return pre;
          },{});

          result['_id'] = instrument_data._id;
          result['instrumentName'] = instrument_data.instrumentName;
          return result;
        }
        else
        {
          return null;
        }
      }).filter(ele => ele);

      this.loading = true;
      this.$axios({
        category: 'manual',
        method: 'put',
        apiName: 'addManualOutput',
        data: {
          outputs: outputList,
          date: timestamp,
          project: this.manualProjectId,
        },
      }).then(async ()=>{
        this.$notifySuccess('新增成功');
        const uploadedTypeId = String(this.getInstrumentType?._id);
        this.outputLoadedTypes = this.outputLoadedTypes.filter(t => t !== uploadedTypeId);
        await this.getOutput(uploadedTypeId);
        this.loading = false;
        this.getInstrumentsFromTable();
        this.updateTable();
      });
    },
  },
};
</script>

<style>
</style>
